import { Component, OnInit } from '@angular/core';

import { ContaService } from '../../../../shared/services/conta/conta.service';

import { EventEmitterService } from '../../../../shared/services/event-emitter/event-emitter.service';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';
import { CONTAS } from '../../../../../environments/environment';
import { LoginService } from '../../../../shared/services/auth/login/login.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: 'side-menu.component.html',
  styleUrls: ['side-menu.component.scss']
})
export class SideMenuComponent implements OnInit {
  public user: any = null;
  public profilePicture: any = null;
  public isAdmin = false;

  constructor(
    private contaService: ContaService,
    private localStorage: LocalStorageService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.getConta();
    this.eventListener();
  }

  getConta() {
    const user = this.localStorage.get('login');

    if (!user) {
      return;
    }

    this.contaService.obterConta(user.PersonId).subscribe((data: any) => {
      data.CpfCnpj = data.CpfCnpj.length === 11 ? this.mascaraCpf(data.CpfCnpj) : this.mascaraCnpj(data.CpfCnpj);
      this.user = data;

      if (data && data.LogoUrl ) {
        this.profilePicture = data.LogoUrl;
      }

      if (this.loginService.isAdmin()) {
        this.isAdmin = true;
      }

    }, (err) => {
      console.error(err);
    });
  }

  mascaraCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
  }

  mascaraCnpj(valor) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }

  eventListener() {
    EventEmitterService.get('refresh-avatar').subscribe((data) => {
      if (data && data.image) {
        this.profilePicture = data.image;
      }
    });

    EventEmitterService.get('remove-avatar').subscribe((data) => {
      this.profilePicture = '';
    });
  }

  isTipoPagueLa() {
    return this.user && this.user.TipoCadastro === 'PagueLa' ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/side-menu/side-menu.component.ts